module.exports = __webpack_public_path__ + "img/新能源汽车_02.fbb817ad.png";